'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ACTIVE_STEP: 'activestep',
  DELETE_FIELD_ROW: 'deletefieldrow',
  FIELD_VALIDATORS: 'data-validators'
};